/**
 * Created by ashahab on 8/23/2017.
 */
import React, { Component } from "react";
import { connect } from "react-redux";
// import Heading from "../../heading/heading";
import ElasticSearchQuery from "../../../actions/elastic-search-query";
import {
    RECEIVED_STUDENT_ASSIGNMENT_DASHBOARD_RESULTS, ElasticSearchTypes,
    ElasticSearchColumns
} from "../../../actions/types";
import apiClient from "../../../actions/api-client";
import { browserHistory } from "react-router";
import WidgetOpenAssignments from "./widgets/Widget-OpenAssignmentsTeacher";
import CreateNewAssignment from './widgets/Widget-CreateNewAssignment'
import WidgetActivityLog from './widgets/Widget-ActivityLog';
import WidgetAlert from './widgets/Widget-Alert';
import config from "../../../config";
import logo from '../../../assets/images/logo2.png'
import stemLabsLogo2 from '../../../assets/images/stem-labs-logo2.png'
import virtualLogo from '../../../assets/images/virtual-logo2.png'
import { Button, Modal, Alert } from "react-bootstrap";
import $ from "jquery";
import TextFieldGroup from "../../forms/text-field-group";
import {
    CognitoUserPool,
    AuthenticationDetails,
    CognitoUser
} from 'amazon-cognito-identity-js';
import ProgressIndicator from "../../progress-indicator/progress-indicator";
import Validator from 'validator';
import isEmpty from 'lodash/isEmpty';
import setCurrentUser from '../../../actions/login-action';
import WidgetCourseStudentView from "./widgets/Widget-CoursesStudentView";
import MaterialIcon from "react-google-material-icons";
import questionIcon from '../../../assets/images/dashboard/question-bank.png'
import activitiesIcon from '../../../assets/images/dashboard/activities.png'
import assignmentIcon from '../../../assets/images/dashboard/assignment.png'
import classesIcon from '../../../assets/images/dashboard/classes.png'
import coursesIcon from '../../../assets/images/dashboard/courses.png'
import reportsIcon from '../../../assets/images/dashboard/reports.png'
import icon2 from '../../../assets/images/icon2.png'
import virtualIcon2 from '../../../assets/images/virtual-icon2.png'
import stemIcon2 from '../../../assets/images/stem-icon-2.png'
import './dashboard-second.css'

class DashboardSecond extends Component {

    constructor(props) {
        super(props);
        this.getAllAssignments = this.getAllAssignments.bind(this);
        this.getAllActivityLog = this.getAllActivityLog.bind(this);
        this.getAllClasses = this.getAllClasses.bind(this);
        this.onChange = this.onChange.bind(this);
        this.getverificationCodeDialog = this.getverificationCodeDialog.bind(this);
        this.verifyUser = this.verifyUser.bind(this);
        this.getCode = this.getCode.bind(this);
        this.handleAlertDismiss = this.handleAlertDismiss.bind(this);
        this.gotIthandleAlertDismiss = this.gotIthandleAlertDismiss.bind(this);
        this.isValid = this.isValid.bind(this);
        this.getValidationState = this.getValidationState.bind(this);
        this.showProfile = this.showProfile.bind(this);
        this.getAssignmentsWaitingForGrades = this.getAssignmentsWaitingForGrades.bind(this);
        this.getAllSubjects = this.getAllSubjects.bind(this);

        this.state = {
            allFilters: [],
            subjects: [],
            noClasses: false,
            showWelcomeDialog: false,
            emailAddressForVerification: '',
            showVerificationCodeDialog: false,
            codeSent: false, errors: {},
            codeForVerification: '', showAlert: false, alertText: '', alertStyle: '',
            isLinked: this.props.auth.user.linkedAccounts && this.props.auth.user.linkedAccounts.gmail ? true : false,
            assignmentsWaitingForGrades:''
        };

    }

    showProfile() {
        if (this.props.auth.user.userType.toLowerCase() === "student") {
            browserHistory.push('/student/profile');
        } else {
            browserHistory.push('/profile');
        }
    }

    componentDidMount() {
        this.getAllAssignments();
        this.getAssignmentsWaitingForGrades()
        this.getAllActivityLog();
        this.getAllSubjects();

        if (this.props.auth.user.federatedIdentity) {
            var additionalParams = {};
            var pathTemplate = '/googleClassroom/getClasses';
            var method = 'POST';
            var additionalParams = { 'accessToken': localStorage.getItem('accessToken') };
            var body = { "userName": this.props.auth.user.userName };

            var params = {

            };
            let that = this
            let count = 0
            let classCount = 0
            apiClient.invokeApi({}, '/class/' + this.props.auth.user.userName, 'GET', {}, {}, '2').then(function (result) {

                let allClasses = result.data.allClasses;
                let occupiedPeriods = [];
                classCount = allClasses.length
                for (let p = 0; p < allClasses.length; p++) {
                    if (allClasses[p] && !allClasses[p].courseId) {
                        count++
                    }
                }

                if (count !== classCount) {
                    apiClient.invokeApi(params, pathTemplate, method, additionalParams, body, "7")
                        .then(function (result) {
                            console.log("result " + result)
                        })
                        .catch(function (err) {
                            console.log(err)
                        });
                } else {
                    if (count === 0 && classCount === 0) {
                        apiClient.invokeApi(params, pathTemplate, method, additionalParams, body, "7")
                            .then(function (result) {
                                console.log("result " + result)
                            })
                            .catch(function (err) {
                                console.log(err)
                            });
                    } else {
                        console.log("delete classes before syncing")
                    }

                }

            }).catch(function (result) {
                console.log(result.data)
            });

        }

        this.getAllClasses();
        if (!localStorage.getItem("dontShowAgainWelcomeNote" + this.props.auth.user.userName)) {
            this.setState({ showWelcomeDialog: true });
        }

        let a = <a style={{ margin: "0" }} title="Click here" onClick={this.showProfile}>profile</a>
        let userObj = JSON.parse(localStorage.getItem('userObj'));
        if (userObj.linkedAccounts && userObj.linkedAccounts.gmail) {
            this.setState({
                gotIt_showAlert: true,
                gotIt_alertStyle: 'warning',
                // gotIt_closeLabel: "Got it!",
                gotIt_alertText: <span id="spanGotIt">You can only view your past Reports and Classes, to create assignments please use your google linked account</span>,
                gotIt_alertID: "gotItAlert"
            });
        }

    }

    getAllClasses() {
        let that = this;
        apiClient.invokeApi({}, '/class/' + this.props.auth.user.userName, 'GET', {}, {}, '2').then(function (result) {
            that.setState({ noClasses: result.data.allClasses.length === 0 });
        }).catch(function (result) {
        });
    }

    getAllActivityLog() {
        let context = this;
        let params = {};
        let pathTemplate = '/user/audit/' + this.props.auth.user.userName;
        apiClient.invokeApi(params, pathTemplate, 'GET', {}, {}, '3').then(function (result) {
            context.setState({ activityLog: result.data.result });
        }).catch(function (error) {

        });
    }

    getAllAssignments() {
        let that = this;
        let elasticSearchQuery = new ElasticSearchQuery();
        elasticSearchQuery.query(ElasticSearchTypes.Assignment + config.stage, ElasticSearchColumns.Assignment, this.props,
            '', 50, 1, { dueDate: { order: "asc" } }, [], function (results, totalRecords) {

                that.setState({ data: results });
            }, true, 'originalOwner : ("' + this.props.auth.user.userName + '") AND assignstatus : (Open)');
    }

    getSubjectDialog() {
        let subjects = this.state.subjects;
        let nodes = [];
        nodes.push(
            <option id="none" value={"none"}>
            ... Select a Subject ...
            </option>,
        );
        if (subjects) {
            subjects.forEach((sub) => {
            nodes.push(
                <option key={sub.id} id={sub.id} value={sub.id}>
                {sub.name}
                </option>,
            );
            });
        }
        let context = this;
        let body = (
            <div>
            <label style={{ padding: "10px" }}>
                Please select a Subject for {this.state.path === 'generateActivity' ? 'Activity Generation' : 'Report'}:
            </label>
            <select
                style={{}}
                onChange={(evt) => {
                context.setState({
                    selectedSubject: evt.target.value,
                });
                }}
            >
                {nodes}
            </select>
            </div>
        );

        return (
            <Modal
            id="hint_modal"
            show={this.state.showSubjectDialog}
            onHide={() => {
                this.setState({ showSubjectDialog: false });
            }}
            container={this}
            aria-labelledby="contained-modal-title"
            >
            <Modal.Header closeButton>
                <Modal.Title id="delete-activity-modal">
                Select Subject For {this.state.path === 'generateActivity' ? 'Activity Generation' : 'Report'}:
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>{body}</Modal.Body>
            <Modal.Footer>
                <Button
                onClick={() => {
                    if (
                    this.state.selectedSubject &&
                    this.state.selectedSubject !== "none"
                    ) {
                        this.setState({ showSubjectDialog: false });
                        if(this.state.path === 'generateActivity'){
                            console.log(this.state.selectedSubject)
                            browserHistory.push({
                                pathname: "questions",
                                state: {
                                    isLandingPage: false,
                                    backToLandingPage: false,
                                    selectedSubject: this.state.selectedSubject,
                                    callPropertyChangeHandler: true
                                },
                            });
                        } else {
                            browserHistory.push({pathname: 'reports/pulse/'+this.state.selectedSubject});
                        }
                    }
                }}
                bsStyle="primary"
                >
                Select
                </Button>
            </Modal.Footer>
            </Modal>
        );
    }
    
    getAllSubjects() {
        let context = this;
        let schoolName = this.props.auth.user.schoolName
            ? this.props.auth.user.schoolName
            : "trial";
        let params = {
            schoolName: schoolName,
            ownerName: this.props.auth.user.userName,
        };
        let pathTemplate =
            "/subjects/ownerName/{ownerName}/schoolName/{schoolName}";
        let method = "GET";
        let additionalParams = {};
        let body = {};
        apiClient
          .invokeApi(params, pathTemplate, method, additionalParams, body)
          .then(function (result) {
            context.setState({
              subjects: result.data,
            });
          });
    }

    getWelcomeDialog() {

        let logo2 = logo;
        if(this.props.appSettings.theme === 'stemLabs'){
            logo2 = stemLabsLogo2;
        } else if(this.props.appSettings.theme === 'virtual'){
            logo2 = virtualLogo;
        }

        let body =
            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <div class="col-md-6 col-lg-6 col-sm-6">
                    <p><strong style={{ color: '#34b3dc', fontSize: '25px' }}>1</strong> The first step is to setup your classes under the<a>classes.</a> For each class you teach, enter the period or class name and an <strong>Enrollment Code</strong> will automatically be generated</p>
                    <br />
                    <p><strong style={{ color: '#34b3dc', fontSize: '25px' }}>2</strong> The next step is to distribute the Enrollment Codes that were generated for each class to the students in that class. Instruct to enter the code during their registration</p>
                </div>
                <div style={{ borderLeft: '#d4d4d4', borderLeftWidth: '1px', borderLeftStyle: 'solid' }} class="col-md-6 col-lg-6 col-sm-6">
                    <div>
                        <span style={{ color: '#ee9400' }}><MaterialIcon icon='assignment' size={43} /></span>
                        <div style={{ display: 'inline', lineHeight: '43px', marginLeft: '15px' }}>
                            You are now ready to assign online activities and learning paths!
                        </div>
                    </div>
                    <br />
                    <div>
                        <span style={{ color: '#4db6ac' }}><MaterialIcon icon='content_paste' size={43} /></span>
                        <div style={{ display: 'inline', lineHeight: '43px', marginLeft: '15px' }}>
                            Assign your own activities or choose from LearnerPal’s!
                        </div>
                    </div>
                    <br />
                    <div>
                        <span style={{ color: '#37bd17' }}><MaterialIcon icon='pie_chart_outlined' size={43} /></span>
                        <div style={{ display: 'inline', lineHeight: '43px', marginLeft: '15px' }}>
                            Analyze Student progress with comprehensive reports!
                        </div>
                    </div>
                </div>
                {/*<div class="col-md-2 col-lg-2 col-sm-2"/>*/}
                {/*<div class="col-md-8 col-lg-8 col-sm-8 col-xs-12">*/}
                {/*<p><strong style={{color:'#34b3dc', fontSize:'25px'}}>3</strong> You are now ready to assign online activities and courses!</p>*/}
                {/*</div>*/}
            </div>;

        return <Modal id="welcome_modal"
            show={this.state.showWelcomeDialog}
            onHide={() => {
                this.setState({ showWelcomeDialog: false });
            }}
            container={this}
            aria-labelledby="contained-modal-title">
            <Modal.Header closeButton>
                <div>
                    <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2">
                        <div class="infoIcon" style={{
                            width: '75px',
                            position: 'relative',
                            marginRight: '100px',
                            float: 'left'
                        }}>
                            <img src={logo2} style={{ height: '70px' }} />
                        </div>
                    </div>
                    <div class="col-lg-8 col-md-8 col-sm-8 col-xs-9" /*"col-lg-9 col-md-9 col-sm-9 col-xs-9"*/ style={{ textAlign: 'center' }}>
                        <div style={{ textAlign: 'center', display: 'inline-block', paddingTop: '13px' }}>
                            <strong style={{ fontSize: '20px' }}>Welcome to LearnerPal</strong>
                            <strong style={{
                                fontStyle: 'italic',
                                display: 'block'
                            }}>Let&apos;s get started...</strong>
                        </div>
                    </div>
                </div>
            </Modal.Header>
            <Modal.Body>
                {body}
            </Modal.Body>
            <Modal.Footer>
                <Modal.Footer>
                    <div style={{ marginTop: '180px' }}>

                        <input type="checkbox" id='searchtipBoxCheckBox' class="css-checkbox" />
                        <label htmlFor='searchtipBoxCheckBox' class="pay_label css-label1">Do not show again</label>

                        <div style={{ textAlign: "center" }}>
                            <span style={{ color: '#4d6573', cursor: 'pointer' }} onClick={() => { window.open("https://youtu.be/hYBphuyCQK4", '_blank') }}><MaterialIcon icon='play_circle_outline' size={55} /></span>
                            <div style={{ display: 'inline', lineHeight: '55px' }}>
                                <a >Take a quick tour with an overview video</a>
                            </div>
                        </div>
                        <Button id="welcomeOkButton" class="btn btn-primary crtBtn" onClick={() => {
                            this.setState({ showWelcomeDialog: false });
                            this.saveWelcomeNotInfo();
                        }}>Ok</Button>
                    </div>
                </Modal.Footer>
            </Modal.Footer>
        </Modal>;
    }

    onChange(event) {
        this.setState({ [event.target.id]: event.target.value });
    }

    getverificationCodeDialog() {
        let body =
            <div>
                <p>Please enter the code sent via email</p>
                <TextFieldGroup
                    error={this.state.errors.codeForVerification}
                    field="codeForVerification"
                    id="codeForVerification"
                    value={this.state.codeForVerification}
                    placeholder="Enter Code"
                    onChange={this.onChange}
                />
            </div>;

        return <Modal id="welcome_modal"
            show={this.state.showVerificationCodeDialog}
            onHide={() => {
                this.setState({ showVerificationCodeDialog: false });
            }}
            container={this}
            aria-labelledby="contained-modal-title">
            <Modal.Header closeButton>
                <div>
                    <h3>
                        Email Verification
                    </h3>
                </div>
            </Modal.Header>
            <Modal.Body>
                {body}
            </Modal.Body>
            <Modal.Footer>
                <Modal.Footer>
                    <div>
                        <Button class="btn btn-primary crtBtn" onClick={() => {
                            this.verifyUser()
                        }}>Verify</Button>
                        <Button class="btn btn-primary crtBtn" onClick={() => {
                            this.getCode();
                        }}>Resend Code</Button>
                    </div>
                </Modal.Footer>
            </Modal.Footer>
        </Modal>;
    }

    getCode() {

        let that = this;
        let userPool = new CognitoUserPool({
            UserPoolId: config.userPoolId,
            ClientId: config.clientId
        });
        let cognitoUser = userPool.getCurrentUser();
        cognitoUser.getSession(function (err, session) {
            if (session) {
                cognitoUser.getAttributeVerificationCode('email',
                    {
                        onSuccess: function (result) {

                        },
                        onFailure: function (err) {
                            that.setState({ showVerificationCodeDialog: false, showAlert: true, alertText: 'Unable to send code, Please try again later', alertStyle: 'danger' });
                            setTimeout(() => {
                                that.setState({ ...that.state, showAlert: false });
                            }, 5000);
                        },
                        inputVerificationCode: null
                    });
            }
        });
    }
    getValidationState() {
        let errors = {};

        if (Validator.isEmpty(this.state.codeForVerification)) {
            errors.codeForVerification = 'This field is required';
        }
        if (this.state.codeForVerification.trim().indexOf(" ") > -1) {
            errors.codeForVerification = 'The code cannot contain spaces';
        }
        if (this.state.codeForVerification.search(/[!@#$%^&*]/) > -1) {
            errors.codeForVerification = 'Special characters are not allowed in the code';
        }

        return {
            errors,
            isValid: isEmpty(errors)
        }
    }
    isValid() {
        const { errors, isValid } = this.getValidationState();
        if (!isValid) {
            this.setState({ errors });
        }
        return isValid;
    }

    verifyUser() {
        if (this.isValid()) {

            const { dispatch } = this.props;
            let that = this;
            let userPool = new CognitoUserPool({
                UserPoolId: config.userPoolId,
                ClientId: config.clientId
            });
            let cognitoUser = userPool.getCurrentUser();
            cognitoUser.getSession(function (err, session) {
                if (session) {

                    cognitoUser.verifyAttribute('email', that.state.codeForVerification, {
                        onSuccess: function (result) {
                            that.setState({
                                showVerificationCodeDialog: false,
                                showAlert: true,
                                alertStyle: 'success',
                                alertText: 'Your email address has been verified successfully'
                            });
                            let userObj = JSON.parse(localStorage.getItem('userObj'));
                            userObj.emailVerified = true;
                            localStorage.setItem('userObj', JSON.stringify(userObj));
                            dispatch({
                                type: 'SET_CURRENT_USER',
                                user: userObj
                            });
                            setTimeout(() => {
                                that.setState({ ...that.state, showAlert: false });
                            }, 5000);
                        },
                        onFailure: function (err) {
                            let errors = {};
                            errors.codeForVerification = err.message;
                            this.setState({ errors });
                        }
                    });
                }
            });
        }
    }

    saveWelcomeNotInfo() {

        let check = $('#searchtipBoxCheckBox').prop('checked');
        if (check === true) {
            localStorage.setItem("dontShowAgainWelcomeNote" + this.props.auth.user.userName, 'true');
        }
    }
    doesShowGotItMessage() {
        localStorage.setItem("doesShowGotItMessage-" + this.props.auth.user.userName, 'true');
    }
    handleAlertDismiss() {
        this.setState({ 'showAlert': false });
    }
    gotIthandleAlertDismiss() {
        this.setState({ 'gotIt_showAlert': false });
    }

    goToUrl(url) {
        browserHistory.push({pathname: url });
    }
    
    callAssignActivity () {
        browserHistory.push({pathname: 'activities', state: {isFromAssignmentToAssignActivity:true, isLandingPage: false}});
    }
    
    callCreateActivity () {
        browserHistory.push({pathname: 'activities', state: {isActivityTypeLandingPage: true}});
    }
    
    callAssignLearningPaths () {
        browserHistory.push({pathname: 'courses', state: {isFromAssignment: true, isLandingPage: false}});
    }

    callCreateNewLearningPaths () {
        browserHistory.push({pathname: 'courses', state: {createNewCourse: true, isLandingPage: false}});
    }

    callViewAllAssignments () {
        browserHistory.push({pathname: 'assignments'});
    }

    callViewAllAssignmentsForGrading () {
        browserHistory.push({pathname: 'assignments', state: {onlyEssayGradingPending: true}});
    }

    callViewAllReports () {
        browserHistory.push({pathname: 'reports'});
    }

    generateQuestionsWithAI () {
        browserHistory.push({
          pathname: "questions",
          state: {
            isActivityTypeLandingPage: true,
            isLandingPage: true,
            showBeforeImportQuestionDialog: false,
            addCustomSubjects: false
          },
        });
    }
    
    showSubjectSelection (path) {
        this.setState({showSubjectDialog: true, path})
    }

    getAssignmentsWaitingForGrades(){
        let elasticSearchQuery = new ElasticSearchQuery();
        let queryString = 'originalOwner : ("' + this.props.auth.user.userName + '")';
        queryString += 'AND essayInReview : ("true")'
        elasticSearchQuery.query(ElasticSearchTypes.Assignment + config.stage, ElasticSearchColumns.Assignment, this.props,
            '', 50, 1, { createdAt: { order: "desc" } }, [], (results, totalRecords) => {
                this.setState({ assignmentsWaitingForGrades: totalRecords });
            }, true, queryString);
    }
    
    render() {
        let context = this;
        let data = this.state.data;

        let logs = this.state.activityLog;

        
        let icon = icon2;
        if(this.props.appSettings.theme === 'stemLabs'){
            icon = stemIcon2;
        } else if(this.props.appSettings.theme === 'virtual'){
            icon = virtualIcon2;
        }
        const days=["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"];
        const months=["January","February","March","April","May","June","July","August","September","October","November","December"];
        const now=new Date();
        const getGreeting= () => {
        const hour = new Date().getHours();

        if (hour < 12) {
            return "Good Morning";
        } else if (hour < 18) {
            return "Good Afternoon";
        } else {
            return "Good Evening";
        }
        }
        let date = days[now.getDay()]+", "+months[now.getMonth()]+" "+now.getDate()+", "+now.getFullYear();
        return (
          <div class='dashboard-container'>
            <div class='dashboard-container-2'>
                <div class="hero" id="hero">
                <div class="mascot">
                    <svg
                    width="80"
                    height="88"
                    viewBox="0 0 105 115"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    >
                    <path
                        d="M30 75 Q30 68 37 65 L48 60 L57 60 L68 65 Q75 68 75 75 L77 108 Q77 111 74 111 L31 111 Q28 111 28 108Z"
                        fill="#8B4060"
                    />
                    <path
                        d="M44 65 L52.5 82 L61 65"
                        fill="#73354F"
                        stroke="#73354F"
                        strokeWidth="1"
                    />
                    <path d="M45 66 L52.5 80 L60 66" fill="#F5EDE0" />
                    <rect
                        x="58"
                        y="82"
                        width="22"
                        height="13"
                        rx="2.5"
                        fill="#fff"
                        stroke="#8B4060"
                        strokeWidth=".8"
                    />
                    <text
                        x="69"
                        y="91.5"
                        text-anchor="middle"
                        font-family="Inter,sans-serif"
                        font-size="7.5"
                        font-weight="800"
                        fill="#6B3050"
                    >
                        PAL
                    </text>
                    <path
                        d="M44 68 Q52.5 74 61 68"
                        stroke="#E8C860"
                        strokeWidth="1"
                        fill="none"
                    />
                    <circle cx="52.5" cy="72" r="2.5" fill="#E8C860" />
                    <rect
                        x="45.5"
                        y="54"
                        width="14"
                        height="12"
                        rx="5"
                        fill="#D4A574"
                    />
                    <ellipse cx="52.5" cy="37" rx="22" ry="24" fill="#D4A574" />
                    <ellipse cx="52.5" cy="23" rx="24" ry="17" fill="#B0B8C8" />
                    <path d="M29 30 Q27 40 32 46 Q30 37 32 29Z" fill="#B0B8C8" />
                    <path d="M76 30 Q78 40 73 46 Q75 37 73 29Z" fill="#B0B8C8" />
                    <ellipse cx="52.5" cy="11" rx="13" ry="10" fill="#B0B8C8" />
                    <ellipse cx="52.5" cy="10" rx="11" ry="8" fill="#C0C8D4" />
                    <path
                        d="M45 9 Q52.5 5 60 9"
                        stroke="#A0A8B4"
                        strokeWidth="1"
                        fill="none"
                    />
                    <circle cx="59" cy="7" r="2.5" fill="#E8C860" />
                    <path
                        d="M42 24 Q52 22 63 24"
                        stroke="#C49468"
                        strokeWidth=".6"
                        fill="none"
                        opacity=".4"
                    />
                    <path
                        d="M36 28 Q40 25.5 45 28.5"
                        stroke="#8A7060"
                        strokeWidth="1.8"
                        fill="none"
                        stroke-linecap="round"
                    />
                    <path
                        d="M60 28.5 Q65 25.5 69 28"
                        stroke="#8A7060"
                        strokeWidth="1.8"
                        fill="none"
                        stroke-linecap="round"
                    />
                    <ellipse cx="40.5" cy="34.5" rx="4.2" ry="4.8" fill="#fff" />
                    <ellipse cx="64.5" cy="34.5" rx="4.2" ry="4.8" fill="#fff" />
                    <circle cx="41.5" cy="34.5" r="3" fill="#3D6090" />
                    <circle cx="65.5" cy="34.5" r="3" fill="#3D6090" />
                    <circle cx="42.5" cy="33.2" r="1.3" fill="#fff" />
                    <circle cx="66.5" cy="33.2" r="1.3" fill="#fff" />
                    <path
                        d="M32.5 33.5 Q34.5 35.5 32.5 37.5"
                        stroke="#C49468"
                        strokeWidth=".7"
                        fill="none"
                        opacity=".5"
                    />
                    <path
                        d="M72.5 33.5 Q70.5 35.5 72.5 37.5"
                        stroke="#C49468"
                        strokeWidth=".7"
                        fill="none"
                        opacity=".5"
                    />
                    <path
                        d="M32 31.5 Q32 27.5 38 27.5 L45.5 27.5 Q48.5 27.5 48.5 31.5 L48.5 37.5 Q48.5 40.5 45.5 40.5 L38 40.5 Q32 40.5 32 37.5Z"
                        fill="none"
                        stroke="#2E6AA8"
                        strokeWidth="2"
                    />
                    <path
                        d="M32 29.5 L29 27.5"
                        stroke="#2E6AA8"
                        strokeWidth="2"
                        stroke-linecap="round"
                    />
                    <path
                        d="M56.5 31.5 Q56.5 27.5 60.5 27.5 L67.5 27.5 Q73 27.5 73 31.5 L73 37.5 Q73 40.5 67.5 40.5 L60.5 40.5 Q56.5 40.5 56.5 37.5Z"
                        fill="none"
                        stroke="#2E6AA8"
                        strokeWidth="2"
                    />
                    <path
                        d="M73 29.5 L76 27.5"
                        stroke="#2E6AA8"
                        strokeWidth="2"
                        stroke-linecap="round"
                    />
                    <path
                        d="M48.5 33.5 Q52.5 31.5 56.5 33.5"
                        stroke="#2E6AA8"
                        strokeWidth="1.5"
                        fill="none"
                    />
                    <path
                        d="M50.5 40 Q52.5 44 54.5 40"
                        stroke="#C49468"
                        strokeWidth="1.2"
                        fill="none"
                        stroke-linecap="round"
                    />
                    <path
                        d="M42 47.5 Q47.5 53 52.5 52 Q57.5 53 63 47.5"
                        stroke="#A07050"
                        strokeWidth="1.8"
                        fill="none"
                        stroke-linecap="round"
                    />
                    <path
                        d="M41 48 Q40 49.5 41.5 50"
                        stroke="#C49468"
                        strokeWidth=".8"
                        fill="none"
                        opacity=".5"
                    />
                    <path
                        d="M64 48 Q65 49.5 63.5 50"
                        stroke="#C49468"
                        strokeWidth=".8"
                        fill="none"
                        opacity=".5"
                    />
                    <circle cx="36" cy="44" r="4.5" fill="#E8A88A" opacity=".3" />
                    <circle cx="69" cy="44" r="4.5" fill="#E8A88A" opacity=".3" />
                    <g transform="translate(76,72) rotate(-15)">
                        <ellipse cx="0" cy="0" rx="7" ry="5" fill="#D4A574" />
                        <ellipse
                        cx="-4"
                        cy="-5"
                        rx="2.2"
                        ry="4"
                        fill="#D4A574"
                        transform="rotate(15)"
                        />
                        <ellipse
                        cx="-1"
                        cy="-6"
                        rx="2"
                        ry="4.5"
                        fill="#D4A574"
                        transform="rotate(5)"
                        />
                        <ellipse
                        cx="2"
                        cy="-6"
                        rx="2"
                        ry="4.5"
                        fill="#D4A574"
                        transform="rotate(-5)"
                        />
                        <ellipse
                        cx="5"
                        cy="-5"
                        rx="2"
                        ry="4"
                        fill="#D4A574"
                        transform="rotate(-15)"
                        />
                        <ellipse
                        cx="-6"
                        cy="-1"
                        rx="2"
                        ry="3.5"
                        fill="#D4A574"
                        transform="rotate(40)"
                        />
                    </g>
                    <path
                        d="M88 62 Q91 60 89 57"
                        stroke="rgba(255,255,255,.4)"
                        strokeWidth="1.5"
                        fill="none"
                        stroke-linecap="round"
                    />
                    <path
                        d="M91 65 Q94 63 92 60"
                        stroke="rgba(255,255,255,.3)"
                        strokeWidth="1.2"
                        fill="none"
                        stroke-linecap="round"
                    />
                    <ellipse
                        cx="28"
                        cy="92"
                        rx="6.5"
                        ry="4.5"
                        fill="#D4A574"
                        transform="rotate(10 28 92)"
                    />
                    <rect
                        x="18"
                        y="86"
                        width="16"
                        height="12"
                        rx="1.5"
                        fill="#2B6DA6"
                        transform="rotate(10 26 92)"
                    />
                    <rect
                        x="19"
                        y="87"
                        width="7"
                        height="10"
                        rx="1"
                        fill="#3B8DD4"
                        transform="rotate(10 26 92)"
                    />
                    <line
                        x1="26"
                        y1="87"
                        x2="26"
                        y2="97"
                        stroke="#1E5280"
                        strokeWidth=".8"
                        transform="rotate(10 26 92)"
                    />
                    <g transform="translate(92,55)">
                        <path
                        d="M0 -4 L1 -1 L4 0 L1 1 L0 4 L-1 1 L-4 0 L-1 -1Z"
                        fill="#F0D060"
                        opacity=".7"
                        />
                    </g>
                    <g transform="translate(85,52) scale(.6)">
                        <path
                        d="M0 -4 L1 -1 L4 0 L1 1 L0 4 L-1 1 L-4 0 L-1 -1Z"
                        fill="#F0D060"
                        opacity=".5"
                        />
                    </g>
                    </svg>
                </div>
                <div class="hero-text">
                    <div class="hero-greeting" id="greeting">
                    {getGreeting()}, {this.props.auth.user.firstName} {this.props.auth.user.lastName}!
                    </div>
                    <h1>What would you like to do today?</h1>
                    <div class="hero-date" id="dateStr">
                    {date}
                    </div>
                </div>
                {/* <button
                    class="hero-dismiss"
                    id="heroDismiss"
                    aria-label="Hide welcome banner"
                >
                    ✕
                </button> */}
                </div>
                { /*  <!-- CREATE & ASSIGN --> */}
                <div class="section">
                    <div class="section-icon" style={{background:"var(--blue-soft)"}}><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#2B6DA6" strokeWidth="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4.5 16.5c-1.5 1.26-2 5-2 5s3.74-.5 5-2c.71-.84.7-2.13-.09-2.91a2.18 2.18 0 0 0-2.91-.09z"/><path d="m12 15-3-3a22 22 0 0 1 2-3.95A12.88 12.88 0 0 1 22 2c0 2.72-.78 7.5-6 11a22.35 22.35 0 0 1-4 2z"/><path d="M9 12H4s.55-3.03 2-4c1.62-1.08 5 0 5 0"/><path d="M12 15v5s3.03-.55 4-2c1.08-1.62 0-5 0-5"/></svg></div>
                    <span class="section-label">Create & Assign</span>
                    <div class="section-line"></div>
                </div>
                <div class="row-2">
                { /*   <!-- ACTIVITIES — green --> */}
                    <div class="tile">
                    <div class="tile-header">
                        <div class="tile-icon" style={{background: "linear-gradient(135deg, #7ba5c9, #2c6ea6)"}}><i class="ti ti-puzzle" aria-hidden="true"></i></div>
                        <div><div class="tile-name" onClick={()=>this.goToUrl('activities')}>Activities</div><div class="tile-desc">Assign from our library or create your own</div></div>
                    </div>
                    <div class="tile-actions">
                        <button class="tlink" onClick={()=>this.callAssignActivity()}><i class="ti ti-send" aria-hidden="true"></i> Assign an activity</button>
                        <button class="tlink" onClick={()=>this.showSubjectSelection('generateActivity').bind(this)}><i class="ti ti-sparkles" aria-hidden="true"></i>Auto Generate</button>
                        <button class="tlink" onClick={()=>this.callCreateActivity()}><i class="ti ti-circle-plus" aria-hidden="true"></i>Create Custom</button>
                    </div>
                    <div class="tile-callout" onClick={()=>this.generateQuestionsWithAI()}>
                        <div class="tile-callout-icon"><i class="ti ti-sparkles" aria-hidden="true"></i></div>
                        <div class="tile-callout-text">
                        <div class="tile-callout-title">Expand your Question Bank</div>
                        <div class="tile-callout-sub">Create custom questions with AI to use in your activities</div>
                        </div>
                    </div>
                    </div>

                    { /* <!-- LEARNING PATHS — purple --> */ }
                    <div class="tile">
                    <div class="tile-header">
                        <div class="tile-icon" style={{background:"linear-gradient(135deg, #7ba5c9, #2c6ea6)"}}><i class="ti ti-stack-2" aria-hidden="true"></i></div>
                        <div><div class="tile-name" onClick={()=>this.goToUrl('courses')}>Learning Paths</div><div class="tile-desc">Guided sequence of activities toward a goal</div></div>
                    </div>
                    <div class="tile-actions">
                        <button class="tlink" onClick={()=>this.callAssignLearningPaths()}><i class="ti ti-send" aria-hidden="true"></i> Assign a learning path</button>
                        <button class="tlink" onClick={()=>this.callCreateNewLearningPaths()}><i class="ti ti-circle-plus" aria-hidden="true"></i> Create your own</button>
                    </div>
                    </div>
                </div>

                {/* <!-- REVIEW --> */}
                <div class="section">
                    <div class="section-icon" style={{background:"var(--amber-soft)"}}><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#D4840A" strokeWidth="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 5H7a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-2"/><rect x="9" y="3" width="6" height="4" rx="1"/><path d="M9 14l2 2 4-4"/></svg></div>
                    <span class="section-label">Review</span>
                    <div class="section-line"></div>
                </div>
                <div class="row-2">
                {/*  <!-- ASSIGNMENTS — amber --> */}
                    <div class="tile">
                    <div class="tile-header">
                        <div class="tile-icon" style={{background:"linear-gradient(135deg,#E09A1A,#B87308)"}}><i class="ti ti-clipboard-check" aria-hidden="true"></i></div>
                        <div><div class="tile-name" onClick={() => this.callViewAllAssignments()}>Assignments</div><div class="tile-desc">Track and review student work</div></div>
                    </div>
                    <div class="tile-actions">
                        <button class="tlink" onClick={()=> this.callViewAllAssignmentsForGrading()}><i class="ti ti-pencil-check" aria-hidden="true"></i> Grade essays</button>
                        <button class="tlink" onClick={() => this.callViewAllAssignments()}>
                            <i class="ti ti-list" aria-hidden="true"></i> All assignments
                        </button>
                    </div>
                    {this.state.assignmentsWaitingForGrades > 0 &&
                        <div class="tile-alert">
                            <div class="tile-alert-dot"></div>
                            <span class="tile-alert-text">{this.state.assignmentsWaitingForGrades} essays waiting for your grade·</span>
                            <button class="tile-alert-btn" onClick={()=> this.callViewAllAssignmentsForGrading()}>Review now →</button>
                        </div>
                    }
                    </div>

                { /* <!-- REPORTS — red --> */}
                    <div class="tile">
                    <div class="tile-header">
                        <div class="tile-icon" style={{background:"linear-gradient(135deg,#E09A1A,#B87308)"}}><i class="ti ti-chart-bar" aria-hidden="true"></i></div>
                        <div><div class="tile-name" onClick={()=> this.callViewAllReports()}>Reports</div><div class="tile-desc">View student progress & analytics</div></div>
                    </div>
                    <div class="tile-actions">
                        <button class="tlink" onClick={()=> this.showSubjectSelection('StandardPulse')}><i class="ti ti-pulse" aria-hidden="true"></i> Standards Pulse</button>
                        <button class="tlink" onClick={()=> this.callViewAllReports()}><i class="ti ti-chart-pie" aria-hidden="true"></i> Full reports</button>
                    </div>
                {/*  <div class="health-teaser">
                        <span class="ht risk"><i class="ti ti-alert-triangle" aria-hidden="true"></i> 5 standards at risk</span>
                        <span class="ht good"><i class="ti ti-circle-check" aria-hidden="true"></i> 7 on track</span>
                    </div> */}
                    </div>
                </div>
                {this.state.showSubjectDialog && this.getSubjectDialog()}
            </div>
          </div>
        );
    }
}


function mapStateToProps(state) {
    return { ...state };
}

export default connect(mapStateToProps)(DashboardSecond);
